import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles(() => ({
  successCheckContainer: {
    display: "flex",
    justifyContent: "center",
    width: "100%",
  },
  successCheckWrapper: {
    fontWeight: 600,
    fontSize: 14,
    color: "#008DAE",
    display: "flex",
    width: "100%",
    justifyContent: "center",
    alignItems: "center",
  },
  disputeText: (props) => ({
    display: "flex",
    fontSize: 11,
    justifyContent: props.isMobile ? "center" : "flex-end",
    paddingLeft: props.isMobile ? 150 : 0,
    textAlign: "right",
  }),
  disputeDeadline: {
    fontSize: 14,
    color: "#FF6D6D",
    textDecoration: "underline",
    cursor: "pointer",
    background: "none",
    border: "none",
    padding: 0,
    marginLeft: "auto",
    display: "block",
    "&:hover": {
      opacity: 0.8,
    },
    paddingLeft: 0,
    textAlign: "left",
    marginLeft: 0,
    justifyContent: "flex-start",
  },
  buttonContainer: {
    display: "flex",
    justifyContent: "flex-start",
    width: "100%",
    maxWidth: "100%",
    gap: 12,
    flexWrap: "nowrap",
  },
  buttonContainerLeftAligned: {
    display: "flex",
    justifyContent: "flex-start",
    width: "100%",
    maxWidth: "100%",
  },
  buttonWrapper: {
    flex: "1 1 0",
    minWidth: 0,
    display: "flex",
    justifyContent: "center",
    "& button": {
      width: "100%",
      fontSize: "clamp(9px, 0.6vw + 4px, 14px)",
      padding: "0 clamp(12px, 1.2vw + 4px, 40px)",
      whiteSpace: "nowrap",
    },
  },
  actionContainer: {
    width: "auto",
    paddingTop: 15,
  },
  statusTextSpacing: {
    marginTop: 8,
    width: "100%",
    marginRight: 0,
    display: "flex",
    justifyContent: "flex-end",
    paddingRight: "clamp(12px, 1.2vw + 4px, 40px)",
  },
  statusTextContainer: {
    width: "100%",
    marginRight: 0,
    display: "flex",
    justifyContent: "flex-end",
    marginTop: 8,
    paddingRight: "clamp(12px, 1.2vw + 4px, 40px)",
  },
  approverNameText: {
    textAlign: "left",
    display: "block",
  },
}));

export const useRevisePayPeriodModalStyles = makeStyles((theme) => ({
  tableContainer: {
    margin: `0px ${theme.spacing(2)}px ${theme.spacing(2)}px 0px`,
    borderRadius: "8px",
    overflow: "hidden",
    border: "1px solid rgba(0, 0, 0, 0.3)",
  },
  tableHeader: {
    backgroundColor: "#e3e9e9",
    "& th": {
      fontWeight: "700",
      fontSize: "16px",
      color: "#37474F",
      borderBottom: "1px solid rgba(0, 0, 0, 0.3)",
    },
    "& th:not(:last-child)": {
      borderRight: "1px solid rgba(0, 0, 0, 0.3)",
    },
  },
  table: {
    borderCollapse: "collapse",
  },
  disputedTableBody: {
    "& td": {
      borderBottom: "1px solid rgba(0, 0, 0, 0.3)",
      color: "#90A4AE",
    },
    "& td:not(:last-child)": {
      borderRight: "1px solid rgba(0, 0, 0, 0.3)",
    },
  },
  revisedTableBody: {
    "& td": {
      borderBottom: "none",
      color: "#37474F",
      fontWeight: "bold",
    },
    "& td:not(:last-child)": {
      borderRight: "1px solid rgba(17, 11, 11, 0.3)",
    },
  },
  comparisonTitle: {
    marginBottom: "20px",
    marginTop: "0px",
  },
  checkboxRow: {
    marginTop: "8px",
    marginLeft: "0px",
  },
}));
